var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkillIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_478",
    "data-name": "Rectangle 478",
    width: 24,
    height: 24,
    transform: "translate(30 30)",
    fill: "#f2f2f2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_18",
    "data-name": "Mask Group 18",
    transform: "translate(-30 -30)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "files-and-folders",
    transform: "translate(32.4 30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    "data-name": "Path 366",
    d: "M23.44,6.492,17.51.561A1.9,1.9,0,0,0,16.155,0H7.235A2.436,2.436,0,0,0,4.8,2.432V16.989a.352.352,0,1,0,.7,0V2.432A1.733,1.733,0,0,1,7.235.7h8.92a1.206,1.206,0,0,1,.3.037V3.058a.352.352,0,1,0,.7,0V1.2L22.8,6.845H18.213a1.059,1.059,0,0,1-1.057-1.058V4.7a.352.352,0,0,0-.7,0V5.788a1.763,1.763,0,0,0,1.761,1.761h5.048a1.213,1.213,0,0,1,.036.294V21.568A1.733,1.733,0,0,1,21.564,23.3H7.235A1.733,1.733,0,0,1,5.5,21.568V18.629a.352.352,0,0,0-.7,0v2.939A2.436,2.436,0,0,0,7.235,24H21.564A2.436,2.436,0,0,0,24,21.568V7.842a1.9,1.9,0,0,0-.56-1.351Z",
    transform: "translate(-4.799 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    "data-name": "Path 367",
    d: "M19.223,26.812a1.363,1.363,0,1,0-1.363-1.363A1.365,1.365,0,0,0,19.223,26.812Zm0-2.023a.66.66,0,1,1-.66.66A.661.661,0,0,1,19.223,24.789Z",
    transform: "translate(-11.33 -12.043)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    "data-name": "Path 368",
    d: "M11.742,20.564H12.5a.352.352,0,1,0,0-.7h-.756a2.229,2.229,0,0,0-2.227,2.227V29.32a2.229,2.229,0,0,0,2.227,2.227H21.773A2.229,2.229,0,0,0,24,29.32V22.088a2.229,2.229,0,0,0-2.227-2.227H14.139a.352.352,0,0,0,0,.7h7.635A1.525,1.525,0,0,1,23.3,22.088v6.4l-3.118-4.348,0,0a1.173,1.173,0,0,0-1.824-.074l-.556.634a.352.352,0,0,0,.529.464l.556-.634a.473.473,0,0,1,.73.028l3.652,5.093a1.526,1.526,0,0,1-1.488,1.2H11.742a1.525,1.525,0,0,1-1.517-1.38l2.722-3.146a.471.471,0,0,1,.547.027l1.271,1.01a1.288,1.288,0,0,0,1.771-.159l.7-.8a.352.352,0,0,0-.529-.464l-.7.8a.585.585,0,0,1-.805.072l-1.271-1.01a1.174,1.174,0,0,0-1.432-.022c-.062.036-2.227,2.573-2.281,2.624V22.088a1.525,1.525,0,0,1,1.523-1.523Z",
    transform: "translate(-7.157 -9.931)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillIcon);
export default __webpack_public_path__ + "static/media/skill-icon.afbe1213f4f17f088e6ef2927cf454c9.svg";
export { ForwardRef as ReactComponent };